import { render, staticRenderFns } from "./contentElementRichText.vue?vue&type=template&id=7d9781a6&scoped=true"
import script from "./contentElementRichText.vue?vue&type=script&lang=js"
export * from "./contentElementRichText.vue?vue&type=script&lang=js"
import style0 from "./contentElementRichText.vue?vue&type=style&index=0&id=7d9781a6&prod&lang=css"
import style1 from "./contentElementRichText.vue?vue&type=style&index=1&id=7d9781a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9781a6",
  null
  
)

export default component.exports